exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".editable-table .delete-cell{padding-left:10px;padding-right:10px}.editable-table .save-cancel-cell{text-align:center}.editable-table .save-cancel-cell button{width:calc(100% - 20px);max-width:100px;margin-right:5px}.editable-table .save-cancel-cell button:first-child{margin-bottom:5px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader!../node_modules/sass-loader/lib/loader.js!./styles/editableTable.scss
// module id = 2182
// module chunks = 43